import { render, staticRenderFns } from "./AI-Tool-Textarea.vue?vue&type=template&id=274a2ce0&scoped=true&"
import script from "./AI-Tool-Textarea.ts?vue&type=script&lang=js&"
export * from "./AI-Tool-Textarea.ts?vue&type=script&lang=js&"
import style0 from "./AI-Tool-Textarea.less?vue&type=style&index=0&id=274a2ce0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274a2ce0",
  null
  
)

export default component.exports